const HARDCODED_FALLBACK = "https://api.inforensic.pro";

// Если VITE_API_* не заданы при сборке, выводим API host из текущего origin:
// context.inforensic.dev → api.inforensic.dev, context.inforensic.pro → api.inforensic.pro.
// Это страхует от ситуации, когда фронт раздаётся, а build-arg забыли передать.
function deriveApiBaseFromLocation(): string {
  if (typeof window === "undefined" || !window.location?.host) {
    return HARDCODED_FALLBACK;
  }
  const host = window.location.host;
  if (host.startsWith("context.")) {
    return `${window.location.protocol}//${host.replace(/^context\./, "api.")}`;
  }
  return HARDCODED_FALLBACK;
}

function normalizeApiBaseUrl(rawUrl: string): string {
  const trimmed = rawUrl.trim();

  if (!trimmed) {
    return deriveApiBaseFromLocation();
  }

  // Handle malformed local values like ":8000" in env.
  if (trimmed.startsWith(":")) {
    return `http://127.0.0.1${trimmed}`;
  }

  // Handle host:port without scheme.
  if (/^(localhost|127\.0\.0\.1)(:\d+)?$/i.test(trimmed)) {
    return `http://${trimmed}`;
  }

  return trimmed;
}

export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || deriveApiBaseFromLocation();

  let normalized = normalizeApiBaseUrl(raw).replace(/\/+$/, "");

  // localhost can resolve to IPv6 (::1), while backend listens on IPv4 in local dev.
  if (import.meta.env.DEV) {
    normalized = normalized.replace(/^http:\/\/localhost(?=[:/]|$)/i, "http://127.0.0.1");
  }

  return normalized;
}
